<template>
  <b-modal
    class="allInvoicesModal"
    title="All Invoices"
    ref="allInvoicesModal"
    hide-header-close
    hide-footer
    size="lg"
    centered
    @open="open"
  >
    <b-table
      striped
      borderless
      :items="allStripeInvoices"
    />
    <p-button type="success" round :disabled="processing" :loading="processing" @click.native="loadMoreInvoices" block v-if="stripeInvoicesHasMore">Load More</p-button>
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      processing: false,
    }
  },
  computed: {
    ...mapGetters([
      'stripeInvoicesHasMore',
      'stripeInvoices',
    ]),
    allStripeInvoices: function() {
      return this.stripeInvoices.map((i) => ({
        invoice_number: i.number.split('-')[1],
        amount: `$${((i.amount_paid + i.amount_remaining) / 100).toFixed(2)}`,
        created: moment(i.created * 1000).format('lll')
      }))
    }
  },
  methods: {
    open() {
      this.$refs.allInvoicesModal.show()
    },
    loadMoreInvoices() {
      this.processing = true
      this.$store.dispatch('loadMoreStripeInvoices').then(() => {
        this.processing = false
      })
    }
  },
}
</script>
<style lang="scss">
.allInvoicesModal {
  .modal-header {
    border-bottom: 0 none;
  }
}
</style>
